import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
import './index.css'

if (import.meta.env.VITE_POSTHOG_API_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    autocapture: false,
  });
}

if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

async function init() {
  // Load runtime config injected by CDK at deploy time.
  // Falls back to VITE_API_URL (local dev) if config.json is absent.
  try {
    const res = await fetch('/config.json');
    if (res.ok) {
      const config = await res.json();
      if (config.apiUrl)          (window as any).__TAS_API_URL__              = config.apiUrl;
      if (config.cognitoClientId) (window as any).__TAS_COGNITO_CLIENT_ID__   = config.cognitoClientId;
      if (config.cognitoPoolId)   (window as any).__TAS_COGNITO_POOL_ID__     = config.cognitoPoolId;
      if (config.cognitoDomain)   (window as any).__TAS_COGNITO_DOMAIN__      = config.cognitoDomain;
      if (config.googleMapsApiKey) (window as any).__TAS_GOOGLE_MAPS_API_KEY__ = config.googleMapsApiKey;
    }
  } catch {
    // config.json not present (local dev) — fall through to env var
  }

  const { default: App } = await import('./App.tsx');
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

init();
